import { useEffect, useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

interface SearchBarProps {
  defaultKeyword?: string;
  placeholder?: string;
  size?: 'md' | 'lg';
}

export default function SearchBar({ defaultKeyword = '', placeholder = '输入影视名称、主演或关键词', size = 'md' }: SearchBarProps) {
  const [keyword, setKeyword] = useState(defaultKeyword);
  const navigate = useNavigate();

  useEffect(() => {
    setKeyword(defaultKeyword);
  }, [defaultKeyword]);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const value = keyword.trim();
    if (!value) return;
    navigate(`/search?q=${encodeURIComponent(value)}`);
  };

  const isLarge = size === 'lg';

  return (
    <form
      onSubmit={handleSubmit}
      className={`flex items-center gap-2 w-full bg-background-50 border border-background-300 rounded-full pl-4 pr-1.5 ${
        isLarge ? 'h-14' : 'h-11'
      }`}
    >
      <i className={`ri-search-line text-foreground-400 ${isLarge ? 'text-xl' : 'text-base'}`}></i>
      <input
        type="text"
        name="keyword"
        value={keyword}
        onChange={(e) => setKeyword(e.target.value)}
        placeholder={placeholder}
        className={`flex-1 bg-transparent outline-none text-foreground-900 placeholder:text-foreground-400 ${
          isLarge ? 'text-base' : 'text-sm'
        }`}
      />
      <button
        type="submit"
        className={`shrink-0 rounded-full bg-accent-500 text-background-50 font-medium whitespace-nowrap hover:bg-accent-600 transition-colors cursor-pointer ${
          isLarge ? 'h-11 px-6 text-sm' : 'h-8 px-4 text-sm'
        }`}
      >
        搜索
      </button>
    </form>
  );
}